'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = require('redux');

var _reduxSaga = require('redux-saga');

var _reduxSaga2 = _interopRequireDefault(_reduxSaga);

var _effects = require('../effects');

var _effects2 = _interopRequireDefault(_effects);

var _announcements = require('../reducers/announcements');

var _announcements2 = _interopRequireDefault(_announcements);

var _clauses = require('../reducers/clauses');

var _clauses2 = _interopRequireDefault(_clauses);

var _app = require('../reducers/app');

var _app2 = _interopRequireDefault(_app);

var _auth = require('../reducers/auth');

var _auth2 = _interopRequireDefault(_auth);

var _authors = require('../reducers/authors');

var _authors2 = _interopRequireDefault(_authors);

var _disciplines = require('../reducers/disciplines');

var _disciplines2 = _interopRequireDefault(_disciplines);

var _hints = require('../reducers/hints');

var _hints2 = _interopRequireDefault(_hints);

var _institutions = require('../reducers/institutions');

var _institutions2 = _interopRequireDefault(_institutions);

var _lawCategories = require('../reducers/lawCategories');

var _lawCategories2 = _interopRequireDefault(_lawCategories);

var _laws = require('../reducers/laws');

var _laws2 = _interopRequireDefault(_laws);

var _lawForm = require('../reducers/lawForm');

var _lawForm2 = _interopRequireDefault(_lawForm);

var _lawSync = require('../reducers/lawSync');

var _lawSync2 = _interopRequireDefault(_lawSync);

var _objectives = require('../reducers/objectives');

var _objectives2 = _interopRequireDefault(_objectives);

var _questions = require('../reducers/questions');

var _questions2 = _interopRequireDefault(_questions);

var _roles = require('../reducers/roles');

var _roles2 = _interopRequireDefault(_roles);

var _roleCategories = require('../reducers/roleCategories');

var _roleCategories2 = _interopRequireDefault(_roleCategories);

var _years = require('../reducers/years');

var _years2 = _interopRequireDefault(_years);

var _models = require('../reducers/models');

var _models2 = _interopRequireDefault(_models);

var _synopses = require('../reducers/synopses');

var _synopses2 = _interopRequireDefault(_synopses);

var _subjects = require('../reducers/subjects');

var _subjects2 = _interopRequireDefault(_subjects);

var _summaries = require('../reducers/summaries');

var _summaries2 = _interopRequireDefault(_summaries);

var _legalBriefs = require('../reducers/legalBriefs');

var _legalBriefs2 = _interopRequireDefault(_legalBriefs);

var _genericMaterials = require('../reducers/genericMaterials');

var _genericMaterials2 = _interopRequireDefault(_genericMaterials);

var _genericMaterialAreas = require('../reducers/genericMaterialAreas');

var _genericMaterialAreas2 = _interopRequireDefault(_genericMaterialAreas);

var _organizingCommittees = require('../reducers/organizingCommittees');

var _organizingCommittees2 = _interopRequireDefault(_organizingCommittees);

var _practiceTests = require('../reducers/practiceTests');

var _practiceTests2 = _interopRequireDefault(_practiceTests);

var _pastPracticeTests = require('../reducers/pastPracticeTests');

var _pastPracticeTests2 = _interopRequireDefault(_pastPracticeTests);

var _mautic = require('../reducers/mautic');

var _mautic2 = _interopRequireDefault(_mautic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sagaMiddleware = (0, _reduxSaga2.default)();

exports.default = function () {

    var store = (0, _redux.createStore)((0, _redux.combineReducers)({
        announcements: _announcements2.default,
        clauses: _clauses2.default,
        app: _app2.default,
        auth: _auth2.default,
        authors: _authors2.default,
        disciplines: _disciplines2.default,
        hints: _hints2.default,
        institutions: _institutions2.default,
        lawCategories: _lawCategories2.default,
        laws: _laws2.default,
        lawForm: _lawForm2.default,
        lawSync: _lawSync2.default,
        objectives: _objectives2.default,
        questions: _questions2.default,
        roles: _roles2.default,
        years: _years2.default,
        models: _models2.default,
        subjects: _subjects2.default,
        synopses: _synopses2.default,
        summaries: _summaries2.default,
        legalBriefs: _legalBriefs2.default,
        genericMaterials: _genericMaterials2.default,
        genericMaterialAreas: _genericMaterialAreas2.default,
        organizingCommittees: _organizingCommittees2.default,
        roleCategories: _roleCategories2.default,
        practiceTests: _practiceTests2.default,
        pastPracticeTests: _pastPracticeTests2.default,
        mautic: _mautic2.default
    }), (0, _redux.applyMiddleware)(sagaMiddleware));

    _effects2.default.forEach(function (effect) {
        return sagaMiddleware.run(effect);
    });

    return store;
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jbGllbnQvc3RvcmUvY29uZmlndXJlU3RvcmUuanMiXSwibmFtZXMiOlsic2FnYU1pZGRsZXdhcmUiLCJzdG9yZSIsImFubm91bmNlbWVudHMiLCJhbm5vdW5jZW1lbnRzUmVkdWNlciIsImNsYXVzZXMiLCJjbGF1c2VzUmVkdWNlciIsImFwcCIsImFwcFJlZHVjZXIiLCJhdXRoIiwiYXV0aFJlZHVjZXIiLCJhdXRob3JzIiwiYXV0aG9yc1JlZHVjZXIiLCJkaXNjaXBsaW5lcyIsImRpc2NpcGxpbmVzUmVkdWNlciIsImhpbnRzIiwiaGludHNSZWR1Y2VyIiwiaW5zdGl0dXRpb25zIiwiaW5zdGl0dXRpb25zUmVkdWNlciIsImxhd0NhdGVnb3JpZXMiLCJsYXdDYXRlZ29yaWVzUmVkdWNlciIsImxhd3MiLCJsYXdzUmVkdWNlciIsImxhd0Zvcm0iLCJsYXdGb3JtUmVkdWNlciIsImxhd1N5bmMiLCJsYXdTeW5jUmVkdWNlciIsIm9iamVjdGl2ZXMiLCJvYmplY3RpdmVzUmVkdWNlciIsInF1ZXN0aW9ucyIsInF1ZXN0aW9uc1JlZHVjZXIiLCJyb2xlcyIsInJvbGVzUmVkdWNlciIsInllYXJzIiwieWVhcnNSZWR1Y2VyIiwibW9kZWxzIiwibW9kZWxzUmVkdWNlciIsInN1YmplY3RzIiwic3ViamVjdHNSZWR1Y2VyIiwic3lub3BzZXMiLCJzeW5vcHNpc1JlZHVjZXIiLCJzdW1tYXJpZXMiLCJzdW1tYXJpZXNSZWR1Y2VyIiwibGVnYWxCcmllZnMiLCJsZWdhbEJyaWVmUmVkdWNlciIsImdlbmVyaWNNYXRlcmlhbHMiLCJnZW5lcmljTWF0ZXJpYWxzUmVkdWNlciIsImdlbmVyaWNNYXRlcmlhbEFyZWFzIiwiZ2VuZXJpY01hdGVyaWFsQXJlYXNSZWR1Y2VyIiwib3JnYW5pemluZ0NvbW1pdHRlZXMiLCJvcmdhbml6aW5nQ29tbWl0dGVlc1JlZHVjZXIiLCJyb2xlQ2F0ZWdvcmllcyIsInJvbGVDYXRlZ29yaWVzUmVkdWNlciIsInByYWN0aWNlVGVzdHMiLCJwcmFjdGljZVRlc3RzUmVkdWNlciIsInBhc3RQcmFjdGljZVRlc3RzIiwicGFzdFByYWN0aWNlVGVzdHNSZWR1Y2VyIiwibWF1dGljIiwibWF1dGljUmVkdWNlciIsImVmZmVjdHMiLCJmb3JFYWNoIiwicnVuIiwiZWZmZWN0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQTs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7QUFDQTs7OztBQUNBOzs7O0FBQ0E7Ozs7OztBQUVBLElBQU1BLGlCQUFpQiwwQkFBdkI7O2tCQUVlLFlBQU07O0FBRWpCLFFBQU1DLFFBQVEsd0JBQ1YsNEJBQWdCO0FBQ1pDLHVCQUFlQyx1QkFESDtBQUVaQyxpQkFBU0MsaUJBRkc7QUFHWkMsYUFBS0MsYUFITztBQUlaQyxjQUFNQyxjQUpNO0FBS1pDLGlCQUFTQyxpQkFMRztBQU1aQyxxQkFBYUMscUJBTkQ7QUFPWkMsZUFBT0MsZUFQSztBQVFaQyxzQkFBY0Msc0JBUkY7QUFTWkMsdUJBQWVDLHVCQVRIO0FBVVpDLGNBQU1DLGNBVk07QUFXWkMsaUJBQVNDLGlCQVhHO0FBWVpDLGlCQUFTQyxpQkFaRztBQWFaQyxvQkFBWUMsb0JBYkE7QUFjWkMsbUJBQVdDLG1CQWRDO0FBZVpDLGVBQU9DLGVBZks7QUFnQnJCQyxlQUFPQyxlQWhCYztBQWlCckJDLGdCQUFRQyxnQkFqQmE7QUFrQnJCQyxrQkFBVUMsa0JBbEJXO0FBbUJyQkMsa0JBQVVDLGtCQW5CVztBQW9CWkMsbUJBQVdDLG1CQXBCQztBQXFCWkMscUJBQWFDLHFCQXJCRDtBQXNCWkMsMEJBQWtCQywwQkF0Qk47QUF1QlpDLDhCQUFzQkMsOEJBdkJWO0FBd0JaQyw4QkFBc0JDLDhCQXhCVjtBQXlCWkMsd0JBQWdCQyx3QkF6Qko7QUEwQlpDLHVCQUFlQyx1QkExQkg7QUEyQlpDLDJCQUFtQkMsMkJBM0JQO0FBNEJaQyxnQkFBUUM7QUE1QkksS0FBaEIsQ0FEVSxFQStCViw0QkFBZ0J6RCxjQUFoQixDQS9CVSxDQUFkOztBQWtDQTBELHNCQUFRQyxPQUFSLENBQWdCO0FBQUEsZUFBVTNELGVBQWU0RCxHQUFmLENBQW1CQyxNQUFuQixDQUFWO0FBQUEsS0FBaEI7O0FBRUEsV0FBTzVELEtBQVA7QUFDSCxDIiwiZmlsZSI6ImNvbmZpZ3VyZVN0b3JlLmpzIiwic291cmNlUm9vdCI6Ii9zcmMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjcmVhdGVTdG9yZSwgY29tYmluZVJlZHVjZXJzLCBhcHBseU1pZGRsZXdhcmUgfSBmcm9tICdyZWR1eCc7XG5pbXBvcnQgY3JlYXRlU2FnYU1pZGRsZXdhcmUgZnJvbSAncmVkdXgtc2FnYSc7XG5pbXBvcnQgZWZmZWN0cyBmcm9tICcuLi9lZmZlY3RzJztcbmltcG9ydCBhbm5vdW5jZW1lbnRzUmVkdWNlciBmcm9tICcuLi9yZWR1Y2Vycy9hbm5vdW5jZW1lbnRzJztcbmltcG9ydCBjbGF1c2VzUmVkdWNlciBmcm9tICcuLi9yZWR1Y2Vycy9jbGF1c2VzJztcbmltcG9ydCBhcHBSZWR1Y2VyIGZyb20gJy4uL3JlZHVjZXJzL2FwcCc7XG5pbXBvcnQgYXV0aFJlZHVjZXIgZnJvbSAnLi4vcmVkdWNlcnMvYXV0aCc7XG5pbXBvcnQgYXV0aG9yc1JlZHVjZXIgZnJvbSAnLi4vcmVkdWNlcnMvYXV0aG9ycyc7XG5pbXBvcnQgZGlzY2lwbGluZXNSZWR1Y2VyIGZyb20gJy4uL3JlZHVjZXJzL2Rpc2NpcGxpbmVzJztcbmltcG9ydCBoaW50c1JlZHVjZXIgZnJvbSAnLi4vcmVkdWNlcnMvaGludHMnO1xuaW1wb3J0IGluc3RpdHV0aW9uc1JlZHVjZXIgZnJvbSAnLi4vcmVkdWNlcnMvaW5zdGl0dXRpb25zJztcbmltcG9ydCBsYXdDYXRlZ29yaWVzUmVkdWNlciBmcm9tICcuLi9yZWR1Y2Vycy9sYXdDYXRlZ29yaWVzJztcbmltcG9ydCBsYXdzUmVkdWNlciBmcm9tICcuLi9yZWR1Y2Vycy9sYXdzJztcbmltcG9ydCBsYXdGb3JtUmVkdWNlciBmcm9tICcuLi9yZWR1Y2Vycy9sYXdGb3JtJztcbmltcG9ydCBsYXdTeW5jUmVkdWNlciBmcm9tICcuLi9yZWR1Y2Vycy9sYXdTeW5jJztcbmltcG9ydCBvYmplY3RpdmVzUmVkdWNlciBmcm9tICcuLi9yZWR1Y2Vycy9vYmplY3RpdmVzJztcbmltcG9ydCBxdWVzdGlvbnNSZWR1Y2VyIGZyb20gJy4uL3JlZHVjZXJzL3F1ZXN0aW9ucyc7XG5pbXBvcnQgcm9sZXNSZWR1Y2VyIGZyb20gJy4uL3JlZHVjZXJzL3JvbGVzJztcbmltcG9ydCByb2xlQ2F0ZWdvcmllc1JlZHVjZXIgZnJvbSAnLi4vcmVkdWNlcnMvcm9sZUNhdGVnb3JpZXMnO1xuaW1wb3J0IHllYXJzUmVkdWNlciBmcm9tICcuLi9yZWR1Y2Vycy95ZWFycyc7XG5pbXBvcnQgbW9kZWxzUmVkdWNlciBmcm9tICcuLi9yZWR1Y2Vycy9tb2RlbHMnO1xuaW1wb3J0IHN5bm9wc2lzUmVkdWNlciBmcm9tICcuLi9yZWR1Y2Vycy9zeW5vcHNlcyc7XG5pbXBvcnQgc3ViamVjdHNSZWR1Y2VyIGZyb20gJy4uL3JlZHVjZXJzL3N1YmplY3RzJztcbmltcG9ydCBzdW1tYXJpZXNSZWR1Y2VyIGZyb20gJy4uL3JlZHVjZXJzL3N1bW1hcmllcyc7XG5pbXBvcnQgbGVnYWxCcmllZlJlZHVjZXIgZnJvbSAnLi4vcmVkdWNlcnMvbGVnYWxCcmllZnMnO1xuaW1wb3J0IGdlbmVyaWNNYXRlcmlhbHNSZWR1Y2VyIGZyb20gJy4uL3JlZHVjZXJzL2dlbmVyaWNNYXRlcmlhbHMnO1xuaW1wb3J0IGdlbmVyaWNNYXRlcmlhbEFyZWFzUmVkdWNlciBmcm9tICcuLi9yZWR1Y2Vycy9nZW5lcmljTWF0ZXJpYWxBcmVhcyc7XG5pbXBvcnQgb3JnYW5pemluZ0NvbW1pdHRlZXNSZWR1Y2VyIGZyb20gJy4uL3JlZHVjZXJzL29yZ2FuaXppbmdDb21taXR0ZWVzJztcbmltcG9ydCBwcmFjdGljZVRlc3RzUmVkdWNlciBmcm9tICcuLi9yZWR1Y2Vycy9wcmFjdGljZVRlc3RzJztcbmltcG9ydCBwYXN0UHJhY3RpY2VUZXN0c1JlZHVjZXIgZnJvbSAnLi4vcmVkdWNlcnMvcGFzdFByYWN0aWNlVGVzdHMnO1xuaW1wb3J0IG1hdXRpY1JlZHVjZXIgZnJvbSAnLi4vcmVkdWNlcnMvbWF1dGljJztcblxuY29uc3Qgc2FnYU1pZGRsZXdhcmUgPSBjcmVhdGVTYWdhTWlkZGxld2FyZSgpO1xuXG5leHBvcnQgZGVmYXVsdCAoKSA9PiB7XG5cbiAgICBjb25zdCBzdG9yZSA9IGNyZWF0ZVN0b3JlKFxuICAgICAgICBjb21iaW5lUmVkdWNlcnMoe1xuICAgICAgICAgICAgYW5ub3VuY2VtZW50czogYW5ub3VuY2VtZW50c1JlZHVjZXIsXG4gICAgICAgICAgICBjbGF1c2VzOiBjbGF1c2VzUmVkdWNlcixcbiAgICAgICAgICAgIGFwcDogYXBwUmVkdWNlcixcbiAgICAgICAgICAgIGF1dGg6IGF1dGhSZWR1Y2VyLFxuICAgICAgICAgICAgYXV0aG9yczogYXV0aG9yc1JlZHVjZXIsXG4gICAgICAgICAgICBkaXNjaXBsaW5lczogZGlzY2lwbGluZXNSZWR1Y2VyLFxuICAgICAgICAgICAgaGludHM6IGhpbnRzUmVkdWNlcixcbiAgICAgICAgICAgIGluc3RpdHV0aW9uczogaW5zdGl0dXRpb25zUmVkdWNlcixcbiAgICAgICAgICAgIGxhd0NhdGVnb3JpZXM6IGxhd0NhdGVnb3JpZXNSZWR1Y2VyLFxuICAgICAgICAgICAgbGF3czogbGF3c1JlZHVjZXIsXG4gICAgICAgICAgICBsYXdGb3JtOiBsYXdGb3JtUmVkdWNlcixcbiAgICAgICAgICAgIGxhd1N5bmM6IGxhd1N5bmNSZWR1Y2VyLFxuICAgICAgICAgICAgb2JqZWN0aXZlczogb2JqZWN0aXZlc1JlZHVjZXIsXG4gICAgICAgICAgICBxdWVzdGlvbnM6IHF1ZXN0aW9uc1JlZHVjZXIsXG4gICAgICAgICAgICByb2xlczogcm9sZXNSZWR1Y2VyLFxuXHRcdFx0eWVhcnM6IHllYXJzUmVkdWNlcixcblx0XHRcdG1vZGVsczogbW9kZWxzUmVkdWNlcixcblx0XHRcdHN1YmplY3RzOiBzdWJqZWN0c1JlZHVjZXIsXG5cdFx0XHRzeW5vcHNlczogc3lub3BzaXNSZWR1Y2VyLFxuICAgICAgICAgICAgc3VtbWFyaWVzOiBzdW1tYXJpZXNSZWR1Y2VyLFxuICAgICAgICAgICAgbGVnYWxCcmllZnM6IGxlZ2FsQnJpZWZSZWR1Y2VyLFxuICAgICAgICAgICAgZ2VuZXJpY01hdGVyaWFsczogZ2VuZXJpY01hdGVyaWFsc1JlZHVjZXIsXG4gICAgICAgICAgICBnZW5lcmljTWF0ZXJpYWxBcmVhczogZ2VuZXJpY01hdGVyaWFsQXJlYXNSZWR1Y2VyLFxuICAgICAgICAgICAgb3JnYW5pemluZ0NvbW1pdHRlZXM6IG9yZ2FuaXppbmdDb21taXR0ZWVzUmVkdWNlcixcbiAgICAgICAgICAgIHJvbGVDYXRlZ29yaWVzOiByb2xlQ2F0ZWdvcmllc1JlZHVjZXIsXG4gICAgICAgICAgICBwcmFjdGljZVRlc3RzOiBwcmFjdGljZVRlc3RzUmVkdWNlcixcbiAgICAgICAgICAgIHBhc3RQcmFjdGljZVRlc3RzOiBwYXN0UHJhY3RpY2VUZXN0c1JlZHVjZXIsXG4gICAgICAgICAgICBtYXV0aWM6IG1hdXRpY1JlZHVjZXJcbiAgICAgICAgfSksXG4gICAgICAgIGFwcGx5TWlkZGxld2FyZShzYWdhTWlkZGxld2FyZSlcblx0KTtcblxuICAgIGVmZmVjdHMuZm9yRWFjaChlZmZlY3QgPT4gc2FnYU1pZGRsZXdhcmUucnVuKGVmZmVjdCkpO1xuXG4gICAgcmV0dXJuIHN0b3JlO1xufVxuO1xuIl19


//////////////////
// WEBPACK FOOTER
// ./src/client/store/configureStore.js
// module id = 2110
// module chunks = 0